import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { displayDateOnly } from '../../Utils';
import { InspectionCustom } from '../../Models/InspectionCustom';
import { HiPencilAlt } from 'react-icons/hi';

export default function InspectionListTable({
  data,
  viewInspection,
}: {
  data: InspectionCustom[];
  viewInspection: (obj: InspectionCustom) => void;
}) {
  const columnHelper = createColumnHelper<InspectionCustom>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => viewInspection(info.row.original)}
          >
            <HiPencilAlt />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.assetName, {
      id: 'assetName',
      header: 'Asset',
      cell: (info) => (
        <div
          className='cursor-pointer text-blue-600'
          onClick={() => viewInspection(info.row.original)}
        >
          {info.row.original.assetName}
        </div>
      ),
      sortingFn: 'alphanumeric',
      // cell: (info) => <i>{info.getValue()}</i>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.assetStatus, {
      id: 'assetStatus',
      header: 'Asset Status',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.result, {
      id: 'result',
      header: 'Result',
      sortingFn: 'alphanumeric',
      cell: (info) => (
        <i>
          {info.getValue() === null
            ? 'Pending'
            : info.getValue() === true
            ? 'Pass'
            : 'Fail'}
        </i>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.typeId, {
      id: 'typeId',
      header: 'Type',
      sortingFn: 'alphanumeric',
      cell: (info) => <i>{info.getValue() === 1 ? 'Pre' : 'Post'}</i>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.dateCreated, {
      id: 'dateCreated',
      header: 'Date',
      cell: (info) => (
        <i>
          {displayDateOnly(info.getValue() ? new Date(info.getValue()!) : null)}
        </i>
      ),
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.userFullName, {
      id: 'userFullName',
      header: 'Name',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      // sorting: [
      //   {
      //     id: 'name',
      //     desc: false,
      //   },
      // ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
